// 特殊直连链接覆盖
const other = {
  _chat_190606: "https://frontend.cjdropshipping.com/chat/",
  _phone_190606: "http://m.cjdropshipping.com/",
  payment: "https://pay.cjdropshipping.com/", // 支付
  wallet: "https://pay.cjdropshipping.com/", // 钱包
  productSku: "https://cache.cjdropshipping.com/", // oss商品地址
  productDetail: "https://cache.cjdropshipping.com/", // oss商品地址
  supplierInfo: "https://cache.cjdropshipping.com/", // 供应商信息oss地址
};

const base = {
  app: "/",
  erp: "/",
  cj: "/",
  push: "/",
  storage: "/",
  tool: "/",
  order: "/",
  caigou: "/",
  source: "/",
  freight: "/",
  cujiaLogisticsFreight: "/",
  authorize: "/",
  lazada: "/",
  shopee: "/",
  woo: "/",
  ebay: "/",
  newlogistics: "/",
  _logistics_190606: "/",
  _chat_190606: "/",
  listed_products: "/",
  _affiliate3_190606: "/",
  _phone_190606: "/",
  orderUsa: "/",
  storehouse: "/",
  warehouseBuildWeb: "/",
  storehousecj: "/",
  media: "/",
  erpSupplierSourceProduct: "/",
  supplierPlanInfo: "/",
  cjSupplier: "/",
  message: "/",
  cjEvaluation: "/",
  cujialog: "/",
  supplier: "/",
  comment: "/",
  "platform-shop": "/",
  _elites_200812: "/",
  collection: "/",
  "platform-product": "/",
  messageCenterCj: "/",
  "product-api": "/",
  "elastic-api": "/",
  "website-api": "/",
  "website-vip-api": "/",
  "website-api-home": "/",
  freightService: "/",
  push: "/",
  operation: "/",
  operationCenterApi: "/",
  statistics: "/",
  "order-center": "/",
  "order-center-vip": "/",
  _cjpacket_210408: "/",
  "product-integration-api": "/",
  "early-warning-web": "/",
  "cj-logistics-rule": "/",
  payment: "/",
  wallet: "/",
  "cujia-message": "/",
  messageCenterWeb: "/",
  userAuthorityCenterWeb: "/",
  operationCenterWeb: "/",
  "cujia-finance-web": "/",
  payCenterLs: "/",
  "storehouse-center-web": "/",
  "cjorder-web": "/",
  "product-app-api": "/",
  "cj-platform-web": "/",
  "source-rest-api": "/",
  "payment-center-web": "/",
  api: "/",
  "platform-order": "/",
  userCenterForeignWeb: "/",
  "quick-search-product-center": "/",
  "cj-logistics-api": "/",
  "chat-web": "/",
  "supplier-center-web": "/",
  "basedata-service": "/",
  "affiliate-center-web": "/",
  "cj-oss-upload": "/",
  "storehouse-center-api": "/",
  "forum-center-web": '/',
  /** 鉴权页面需要使用到,这个暂时测试环境的代理的鉴权页面需要 */
  "securityCenter": '/',
  'cogs-service': '/'
};

exports.apiFactory = (baseApi = "/") => ({
  ...Object.keys(base).reduce((a, b) => ({ ...a, [b]: baseApi }), {}),
  ...other,
});
